import { Host, h } from "@stencil/core";
import state from "../store";
export class GxgPills {
    el;
    /**
     * Returns an array with the id's of all the pills
     */
    async getPills(onlyEnabled = true) {
        const pillsIds = [];
        let pills = Array.from(this.el.querySelectorAll("gxg-pill"));
        if (onlyEnabled) {
            pills = pills.filter((pill) => !pill.disabled);
        }
        pills.forEach((pill) => {
            pillsIds.push(pill.id);
        });
        return pillsIds;
    }
    render() {
        return (h(Host, { class: { mercury: state.mercury } }, h("div", { class: "pills-wrapper" }, h("slot", null))));
    }
    static get is() { return "gxg-pills"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["pills.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["pills.css"]
        };
    }
    static get methods() {
        return {
            "getPills": {
                "complexType": {
                    "signature": "(onlyEnabled?: boolean) => Promise<string[]>",
                    "parameters": [{
                            "name": "onlyEnabled",
                            "type": "boolean",
                            "docs": ""
                        }],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<string[]>"
                },
                "docs": {
                    "text": "Returns an array with the id's of all the pills",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=pills.js.map
